import i18n from '@/lang/index'
export const columnData = [
    {
        key: 'sn',
        text: i18n.t('invoicesCenter.transferconfigColumnsn'),
        width: '200px',
        fixed: 'left'
    },
    {
        key: 'stateDesc',
        text: i18n.t('invoicesCenter.transferconfigColumnstate'),
        width: '200px',
        fixed: 'left',
        remind: {
            text: `
                ${i18n.t('invoicesCenter.transferconfigStatedraftdesc')}<br/>
                ${i18n.t('invoicesCenter.transferconfigStateissueddesc')}<br/>
                ${i18n.t('invoicesCenter.transferconfigStatepickingdesc')}<br/>
                ${i18n.t('invoicesCenter.transferconfigStatepickeddesc')}<br/>
                ${i18n.t('invoicesCenter.transferconfigStateshippeddesc')}<br/>
                ${i18n.t('invoicesCenter.transferconfigStatesigneddesc')}<br/>
                ${i18n.t('invoicesCenter.transferconfigStatecheckingdesc')}<br/>
                ${i18n.t('invoicesCenter.transferconfigStatestoreddesc')}<br/>
                ${i18n.t('invoicesCenter.transferconfigStatecanceleddesc')}<br/>
                ${i18n.t('invoicesCenter.transferconfigStatecancelapplydesc')}<br/>
          `,
            style: {
                width: '400px',
                'font-size': '12px',
                'text-align': 'left'
            }
        },
        template: () => {
            return `
              <div style="display:flex;align-items:center;">
                  <span v-if="row.state == 0" style="width:10px;height:10px;border-radius:35%;margin-right:10px;background:#F8475F;"></span>
                  <span v-else-if="[4,6,8,12,14].includes(+row.state)" style="width:10px;height:10px;border-radius:35%;margin-right:10px;background:#43D268;"></span>
                  <span v-else-if="[5,7,11].includes(+row.state)" style="width:10px;height:10px;border-radius:35%;margin-right:10px;background:#FF9000;"></span>
                  <span v-else-if="[1,9,10].includes(+row.state)" style="width:10px;height:10px;border-radius:35%;margin-right:10px;background:#067CF2;"></span>
                  <span v-else-if="row.state == 2" style="width:10px;height:10px;border-radius:35%;margin-right:10px;background:#BD73D3;"></span>
                  <span v-else-if="row.state == 19" style="width:10px;height:10px;border-radius:35%;margin-right:10px;background:#F8475F;"></span>
                  <span v-else style="width:10px;height:10px;border-radius:35%;margin-right:10px;background:#999;"></span>
                  <span>{{row.stateDesc}}</span>
              </div>
          `
        }
    },
    {
        key: 'ifDiscrepancy',
        text: i18n.t('invoicesCenter.transferconfigColumndiscrepancy'),
        width: '180px',
        template: () => {
            return `
                <div>{{row.ifDiscrepancy === 'Y' ? '${i18n.t('invoicesCenter.transferconfigYestext')}' : '${i18n.t('invoicesCenter.transferconfigNotext')}'}}</div>
            `
        }
    },
    {
        key: 'outMarketName',
        text: i18n.t('invoicesCenter.transferconfigColumnoutmarket'),
        width: '150px'
    },
    { key: 'inMarketName', text: i18n.t('invoicesCenter.transferconfigColumninmarket'), width: '150px' },

    { key: 'totalNum', text: i18n.t('invoicesCenter.transferconfigColumnplannum'), width: '180px',
    template: (e, row) => {
        return `<span>{{row.totalNum==='0'?'':row.totalNum}}<span>`
    }
},
    { key: 'outNum', text: i18n.t('invoicesCenter.transferconfigColumnoutnum'), width: '180px',
    template: (e, row) => {
        return `<span>{{row.outNum==='0'?'':row.outNum}}<span>`
    }
},
    { key: 'outPackageNum', text: i18n.t('invoicesCenter.transferconfigColumnoutpackage'), width: '150px',
        template: (e, row) => {
            return `<span>{{row.outPackageNum==='0'?'':row.outPackageNum}}<span>`
        }
    },

    {
        key: 'outNumDifference',
        text: i18n.t('invoicesCenter.transferconfigColumnoutdiff'),
        width: '150px',
        template: (e, row) => {
            return `<span style="color:red">{{row.outNumDifference==='0'?'':row.outNumDifference}}<span>`
        }
    },
    { key: 'difReason', text: i18n.t('invoicesCenter.transferconfigColumndiffreason'), width: '170px',},
    { key: 'inNum', text: i18n.t('invoicesCenter.transferconfigColumninnum'), width: '150px',
    template: (e, row) => {
        return `<span>{{row.inNum==='0'?'':row.inNum}}<span>`
    }
},
    { key: 'logisticPackageCheckNum', text: i18n.t('invoicesCenter.transferconfigColumninpackage'), width: '150px',
        template: (e, row) => {
            return `<span>{{row.logisticPackageCheckNum==='0'?'':row.logisticPackageCheckNum}}<span>`
        }
    },
    {
        key: 'inNumDifference',
        text: i18n.t('invoicesCenter.transferconfigColumnindiff'),
        width: '150px',
        template: (e, row) => {
            return `<span  style="color:red">{{row.inNumDifference==='0'?'':row.inNumDifference}}<span>`
        }
    },
    { key: 'remark', text: i18n.t('invoicesCenter.transferconfigColumnremark'), width: '180px' },
    { key: 'createUserName', text: i18n.t('invoicesCenter.transferconfigColumncreator'), width: '150px' },
    {
        key: 'createTime',
        text: i18n.t('invoicesCenter.transferconfigColumncreatetime'),
        width: '160px',
    },
    { key: 'updateTime', text: i18n.t('invoicesCenter.transferconfigColumnupdatetime'), width: '160px' },
    { key: 'updateUserName', text: i18n.t('invoicesCenter.transferconfigColumnmodifier'), width: '150px' }

]
export const options = {
    searchItem: [
        {
            id: '2',
            type: 'input',
            size: 'small',
            clearable: true,
            placeholder: i18n.t('invoicesCenter.transferconfigPlaceholdersn'),
            label: i18n.t('invoicesCenter.transferconfigLabelsn'),
            value: '',
            resField: 'invoicesNoList'
        },
        {
            id: '11',
            type: 'input',
            size: 'small',
            clearable: true,
            placeholder: i18n.t('invoicesCenter.transferconfigPlaceholderexpress'),
            label: i18n.t('invoicesCenter.transferconfigLabelexpress'),
            value: '',
            resField: 'expressNo'
        },
        {
            id: '1',
            type: 'select',
            size: 'small',
            clearable: true,
            placeholder: i18n.t('invoicesCenter.transferconfigPlaceholderstate'),
            label: i18n.t('invoicesCenter.transferconfigLabelstate'),
            value: [],
            resField: 'state',
            multiple: true,
            list: [
                { name: i18n.t('invoicesCenter.transferconfigStatedraft'), value: '1' },
                { name: i18n.t('invoicesCenter.transferconfigStateissued'), value: '4' },
                { name: i18n.t('invoicesCenter.transferconfigStatepicking'), value: '5' },
                { name: i18n.t('invoicesCenter.transferconfigStatepicked'), value: '6' },
                { name: i18n.t('invoicesCenter.transferconfigStatepacked'), value: '8' },
                { name: i18n.t('invoicesCenter.transferconfigStateshipped'), value: '9' },
                { name: i18n.t('invoicesCenter.transferconfigStatesigned'), value: '10' },
                { name: i18n.t('invoicesCenter.transferconfigStatechecking'), value: '11' },
                { name: i18n.t('invoicesCenter.transferconfigStatestored'), value: '14' },
                { name: i18n.t('invoicesCenter.transferconfigStatecancelapply'), value: '19' },
                { name: i18n.t('invoicesCenter.transferconfigStatecanceled'), value: '0' }
            ]
        },
        {
            id: 'ifDiscrepancy',
            type: 'select',
            size: 'small',
            clearable: true,
            placeholder: i18n.t('invoicesCenter.transferconfigPlaceholderselect'),
            label: i18n.t('invoicesCenter.transferconfigLabeldiscrepancy'),
            value: '',
            resField: 'ifDiscrepancy',
            multiple: false,
            list: [
                { value: 'Y', name: i18n.t('invoicesCenter.transferconfigYestext') },
                { value: 'N', name: i18n.t('invoicesCenter.transferconfigNotext') }
            ]
        },
        {
            id: 'hasDiscrepancy',
            type: 'select',
            size: 'small',
            clearable: true,
            placeholder: i18n.t('invoicesCenter.transferconfigPlaceholderselect'),
            label: i18n.t('invoicesCenter.transferconfigLabelhasdiscrepancy'),
            value: '',
            resField: 'hasDiscrepancy',
            multiple: false,
            list: [
                { value: 'Y', name: i18n.t('invoicesCenter.transferconfigYestext') },
                { value: 'N', name: i18n.t('invoicesCenter.transferconfigNotext') }
            ]
        },
        {
            id: '4',
            type: 'storeSelector',
            placeholder: i18n.t('invoicesCenter.transferconfigPlaceholderinmarket'),
            label: i18n.t('invoicesCenter.transferconfigColumninmarket'),
            // modelKey: 'Id',
            value: [],
            resField: 'inMarketIds'
        },
        {
            // id: 'goodsNo',
            // type: 'goodsNoSelector',
            // placeholder: '请选择货号',
            // label: '货号',
            // modelKey: 'goodsNo',
            // multiple: true, //单选
            // // value: '', //单选
            // value: [],//多选
            // resField: 'goodsNo'
            id: 'goodsNo',
            type: 'goodsNoSelector',
            placeholder: i18n.t('invoicesCenter.transferconfigPlaceholdergoodsno'),
            label: i18n.t('invoicesCenter.transferconfigLabelgoodsno'),
            modelKey: 'goodsNo',
            multiple: true,
            value: '',
            inputShow: true,
            slectShow: false,
            resField: 'goodsNo'
        },
        // {
        //     id: '7',
        //     type: 'selectUser',
        //     size: 'small',
        //     clearable: true,
        //     placeholder: '请选择创建人',
        //     label: '创建人',
        //     value: '',
        //     resField: 'createUserId',
        //     list: [],
        //     filterable: true,
        //     remote: true
        // },
        {
            id: "UserInput",
            type: "input",
            size: "small",
            clearable: true,
            placeholder: i18n.t('invoicesCenter.transferconfigPlaceholdercreator'),
            label: i18n.t('invoicesCenter.transferconfigLabelcreatorsearch'),
            value: "",
            resField: "createUserName",
        },
        {
            id: '8',
            type: 'daterange',
            size: 'small',
            clearable: true,
            placeholder: i18n.t('invoicesCenter.transferconfigPlaceholdercreatetime'),
            label: i18n.t('invoicesCenter.transferconfigColumncreatetime'),
            value: '',
            resField: 'createTime',
            valueFormat: 'yyyy-MM-dd'
        },
        {
            id: '9',
            type: 'daterange',
            size: 'small',
            clearable: true,
            placeholder: i18n.t('invoicesCenter.transferconfigPlaceholderupdatetime'),
            label: i18n.t('invoicesCenter.transferconfigColumnupdatetime'),
            value: '',
            resField: 'updateTime',
            valueFormat: 'yyyy-MM-dd'
        }
    ],
    // 确认按钮
    sureBtnVisable: true,
    sureBtnType: 'primary',
    sureBtnSize: 'medium',
    sureBtnText: i18n.t('invoicesCenter.transferconfigBtnsearch'),
    //重置按钮
    restBtnVisable: true,
    restBtnType: '',
    restBtnSize: 'medium',
    restBtnText: i18n.t('invoicesCenter.transferconfigBtnreset')
}
